import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getAllRanksAndApps } from '../../actions/topn';
import { cleanSearchRecommend } from '../../actions/search';
import Loading from '../../components/Loading/Loading';
import SoftCard from '../../components/SoftCard/SoftCard';
import CommReco from '../../components/CommReco/CommReco';
import { CONTEXT } from '../../config';
import styles from './Topn.module.less';

const selectAllRanksSofts = createSelector(
  state => state.topn,
  topn => topn.allRanksAndApps,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(() => {
  const dispatch = useDispatch();
  const allRanksSoftsData = useSelector(selectAllRanksSofts);
  const logInfoData = useSelector(selectLogInfo);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Rank`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  const handleShowMore = useCallback(
    rankData => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: 'RankMore',
          label: '',
          param2: {
            source: `Rank||${rankData.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `Rank||${rankData.code}`,
          source_pp: logInfoData.source_p,
        }),
      );
      dispatch(cleanSearchRecommend());
    },
    [dispatch],
  );

  useEffect(() => {
    if (!allRanksSoftsData || allRanksSoftsData.length === 0) {
      dispatch(getAllRanksAndApps());
    }
  }, [allRanksSoftsData, dispatch]);

  useEffect(() => {
    // 排行页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Rank',
        label: '',
        param2: {
          source: 'Rank',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Rank',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);
  return (
    <>
      {allRanksSoftsData && allRanksSoftsData.length > 0 ? (
        <>
          <div className={styles.topn}>
            {allRanksSoftsData.map((rank, i) => (
              <div className={styles.topn_column} key={i}>
                <div className={styles.topn_top}>
                  <div className={styles.topn_top_title}>{rank.desc}</div>
                  <Link
                    className={styles.topn_top_link}
                    onClick={() => {
                      handleShowMore(rank);
                    }}
                    to={{
                      pathname: `${CONTEXT}/topnmore/${rank.code}/${rank.desc}`,
                    }}
                  >
                    更多
                  </Link>
                </div>
                <div className={styles.topn_soft_cards}>
                  {rank.apps &&
                    rank.apps.length > 0 &&
                    rank.apps.map((soft, j) => {
                      if (j < 6) {
                        return (
                          <SoftCard
                            soft={soft}
                            logInfo={{ source: `Rank||${rank.code}` }}
                            key={j}
                          />
                        );
                      }
                      return '';
                    })}
                </div>
              </div>
            ))}
          </div>
          <CommReco logInfo={{ tag: 'Rank' }} />
        </>
      ) : (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
    </>
  );
});
